import script from "./ClubList.vue?vue&type=script&setup=true&lang=js"
export * from "./ClubList.vue?vue&type=script&setup=true&lang=js"

import "./ClubList.vue?vue&type=style&index=0&id=7c4916dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c4916dc"]])

export default __exports__